/* OSMODI v2 behaviours. No dependencies. Everything is optional: if an element is missing, that feature is skipped. */
(function () {
  'use strict';

  /* Keep the overview and care advice visible; use native disclosures for longer sections. */
  function organizeDescriptions(scope) {
    scope.querySelectorAll('[data-osv-description]').forEach(function (root) {
      if (root.dataset.osvOrganized) return;
      var headingTag = root.querySelector(':scope > h2') ? 'H2' : 'H3';
      var destination = null;
      Array.from(root.childNodes).forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === headingTag) {
          destination = null;
          if (/safety|care|storage|how to use|how should i apply|ingredients/i.test(node.textContent)) return;
          var details = document.createElement('details');
          details.className = 'osv-description-section';
          var summary = document.createElement('summary');
          root.insertBefore(details, node);
          details.appendChild(summary);
          summary.appendChild(node);
          destination = document.createElement('div');
          destination.className = 'osv-description-section__body';
          details.appendChild(destination);
        } else if (node.nodeType === 1 && node.tagName === 'DETAILS') {
          destination = null;
        } else if (destination) {
          destination.appendChild(node);
        }
      });
      root.dataset.osvOrganized = 'true';
    });
  }
  organizeDescriptions(document);
  document.addEventListener('shopify:section:load', function (event) {
    organizeDescriptions(event.target);
  });

  var mEl = document.getElementById('osmodi-v2-market');
  var M = { code: 'AE', cutoff: true, transitMin: 1, transitMax: 3, freeThreshold: 0, cod: true, moneyFormat: '{{amount}}' };
  try { if (mEl) M = Object.assign(M, JSON.parse(mEl.textContent)); } catch (e) {}

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var track = function (name, params) {
    if (typeof window.osmodiTrack === 'function') window.osmodiTrack(name, params || {});
  };

  /* ---------- dispatch cut-off (14:00 Asia/Dubai) and arrival dates ---------- */
  function dubaiNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Dubai' })); }
  // Sunday is the one non-working day for dispatch out of Dubai.
  function addBiz(from, n) { var d = new Date(from), c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; } return d; }
  function fmt(d) { return d.toLocaleDateString(document.documentElement.lang || 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }

  function updateDispatch() {
    var now = dubaiNow(), cut = new Date(now); cut.setHours(14, 0, 0, 0);
    var before = now < cut, shipDay = before ? now : addBiz(now, 1);
    var min = addBiz(shipDay, M.transitMin), max = addBiz(shipDay, M.transitMax);
    var arrives = M.cutoff ? 'Arrives ' + fmt(min) : 'Arrives ' + fmt(min) + ' – ' + fmt(max);
    var chip = document.querySelector('[data-osv-dispatch]');
    if (chip) {
      var text;
      if (M.cutoff) {
        if (before) {
          var ms = cut - now;
          text = 'Order in the next ' + Math.floor(ms / 36e5) + 'h ' + Math.floor(ms % 36e5 / 6e4) + 'm for delivery ' + fmt(min);
        } else {
          text = 'Cut-off passed. Order now for delivery ' + fmt(min);
        }
      } else {
        text = 'Ships ' + (before ? 'today' : 'tomorrow') + ' by DHL Express. ' + arrives + ', duties paid';
      }
      if (chip.textContent !== text) chip.textContent = text;
    }
    document.querySelectorAll('[data-osv-arrives]').forEach(function (el) {
      if (el.textContent !== arrives) el.textContent = arrives;
    });
  }
  updateDispatch();
  // A countdown is only worth a timer while the tab is actually being looked at.
  var dispatchTimer = null;
  function startDispatchTimer() {
    if (dispatchTimer === null) dispatchTimer = setInterval(updateDispatch, 60000);
  }
  function stopDispatchTimer() {
    if (dispatchTimer !== null) { clearInterval(dispatchTimer); dispatchTimer = null; }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopDispatchTimer(); } else { updateDispatch(); startDispatchTimer(); }
  });
  if (!document.hidden) startDispatchTimer();

  /* ---------- bestseller filters (client side, cards carry data-tags and data-price) ---------- */
  document.querySelectorAll('[data-osv-filters]').forEach(function (bar) {
    var grid = document.querySelector(bar.dataset.osvFilters); if (!grid) return;
    var cards = grid.querySelectorAll('.osv-card');
    var limit = parseInt(bar.dataset.osvLimit || '4', 10);
    var under = parseFloat(bar.dataset.osvUnder || '0');
    var status = document.createElement('p');
    status.className = 'osv-filters__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    bar.insertAdjacentElement('afterend', status);

    function apply(f, announce) {
      var shown = 0, matched = 0;
      cards.forEach(function (c) {
        var tags = (c.dataset.tags || '').toLowerCase().split(',');
        var price = parseFloat(c.dataset.price || '0');
        var ok = f === 'all' || (f === 'under' ? price < under : tags.indexOf(f) > -1);
        if (ok) matched++;
        if (ok && shown < limit) { c.classList.remove('is-hidden'); shown++; } else { c.classList.add('is-hidden'); }
      });
      if (announce) {
        status.textContent = matched === 0
          ? 'Nothing in this filter yet. Showing everything instead.'
          : 'Showing ' + shown + ' of ' + matched + ' bottles.';
        if (matched === 0) { cards.forEach(function (c, i) { if (i < limit) c.classList.remove('is-hidden'); }); }
      }
      return matched;
    }

    bar.querySelectorAll('[data-f]').forEach(function (b) {
      b.addEventListener('click', function () {
        bar.querySelectorAll('[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var matched = apply(b.dataset.f, true);
        track('bestsellers_filter_click', { filter: b.dataset.f, results: matched });
      });
    });
    apply('all', false);
  });

  /* ---------- geo suggest: offer once, never force, remember the answer ---------- */
  (function () {
    var box = document.querySelector('[data-osv-suggest]'); if (!box) return;
    var STORE_KEY = 'osv-market-suggest-dismissed';
    var dismissed = null;
    try { dismissed = window.localStorage.getItem(STORE_KEY); } catch (e) {}
    var options = {};
    try { options = JSON.parse(box.dataset.osvSuggest); } catch (e) { return; }

    var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '');
    var lang = (navigator.language || '').toUpperCase();
    var guess = null;
    if (/^America\//.test(tz)) guess = /Toronto|Vancouver|Edmonton|Winnipeg|Halifax|Montreal|Regina|St_Johns/.test(tz) ? 'CA' : 'US';
    else if (/^Europe\/(London|Belfast)/.test(tz)) guess = 'GB';
    else if (/^Europe\//.test(tz)) guess = 'DE';
    else if (/Riyadh/.test(tz)) guess = 'SA';
    else if (/Dubai/.test(tz)) guess = 'AE';
    if (lang.endsWith('-CA')) guess = 'CA';
    if (lang.endsWith('-GB')) guess = 'GB';
    if (!guess || guess === M.code || !options[guess] || dismissed === guess) return;

    box.querySelector('[data-osv-suggest-text]').textContent =
      'Shipping to ' + options[guess] + '? Switch for local pricing, duties-paid delivery and payment options.';
    box.classList.add('is-show');
    track('market_suggest_shown', { suggested: guess, current: M.code });

    box.querySelector('[data-osv-suggest-yes]').addEventListener('click', function () {
      var form = box.querySelector('form');
      var input = form.querySelector('input[name="country_code"]');
      input.value = guess;
      track('market_suggest_accepted', { suggested: guess });
      form.submit();
    });
    box.querySelector('[data-osv-suggest-no]').addEventListener('click', function () {
      box.classList.remove('is-show');
      try { window.localStorage.setItem(STORE_KEY, guess); } catch (e) {}
      track('market_suggest_dismissed', { suggested: guess });
    });
  })();

  /* ---------- quiz ---------- */
  document.querySelectorAll('[data-osv-quiz]').forEach(function (root) {
    var products = [];
    try { products = JSON.parse(root.querySelector('[data-osv-quiz-products]').textContent); } catch (e) {}
    var Q = [
      { q: 'How do you want to smell?', opts: [['Clean', 'Airy, soft, polished', '#dbe7fb'], ['Warm', 'Amber, vanilla, comfort', '#e6b77a'], ['Expressive', 'Fruity, bright, memorable', '#e2c1ea'], ['Deep', 'Oud, tobacco, smoke', '#4a2e2a']] },
      { q: 'When will you wear it most?', opts: [['Office and daytime', 'Close to skin, no complaints', '#dbe7fb'], ['Evenings out', 'Meant to be noticed', '#e6b77a'], ['Everything', 'One bottle, every day', '#e2c1ea'], ['Occasions', 'Weddings, holidays, gifts', '#4a2e2a']] },
      { q: 'How strong should it be?', opts: [['Light', 'Fades by the afternoon', '#dbe7fb'], ['Medium', 'Lasts the workday', '#e6b77a'], ['Strong', 'Still there at night', '#e2c1ea'], ['Very strong', 'Leaves a trail', '#4a2e2a']] }
    ];
    var qi = 0, answers = [];
    var el = function (s) { return root.querySelector(s); };
    var optsBox = el('[data-qopts]');
    if (!optsBox) return;
    optsBox.setAttribute('role', 'group');

    // "Find your scent" sits in the copy column; it brings the panel into view and hands over focus
    // so the quiz can be started from the keyboard as well as the mouse.
    var startBtn = root.querySelector('[data-osv-quiz-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        var box = root.querySelector('.osv-quiz__box');
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (box && box.scrollIntoView) {
          box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
        }
        var first = root.querySelector('.osv-qopt');
        if (first) { setTimeout(function () { first.focus(); }, still ? 0 : 340); }
      });
    }

    function renderQ() {
      var s = Q[qi];
      el('[data-qq]').textContent = s.q;
      el('[data-qstep]').textContent = 'Question ' + (qi + 1) + ' of 3';
      el('[data-qpct]').textContent = Math.round((qi + 1) / 3 * 100) + '%';
      el('[data-qfill]').style.width = ((qi + 1) / 3 * 100) + '%';
      optsBox.setAttribute('aria-label', s.q);
      optsBox.innerHTML = s.opts.map(function (o) {
        return '<button type="button" class="osv-qopt" aria-pressed="false" data-v="' + o[0] + '">' +
          '<i style="background:' + o[2] + '" aria-hidden="true"></i>' +
          '<span><b>' + o[0] + '</b><small>' + o[1] + '</small></span></button>';
      }).join('');
      var nx = el('[data-qnext]');
      nx.disabled = true;
      nx.textContent = qi === 2 ? 'See my match' : 'Next';
      var previous = answers[qi];
      root.querySelectorAll('.osv-qopt').forEach(function (o) {
        if (previous && o.dataset.v === previous) { o.setAttribute('aria-pressed', 'true'); nx.disabled = false; }
        o.addEventListener('click', function () {
          root.querySelectorAll('.osv-qopt').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          o.setAttribute('aria-pressed', 'true');
          answers[qi] = o.dataset.v;
          nx.disabled = false;
        });
      });
    }
    renderQ();

    el('[data-qnext]').addEventListener('click', function () {
      if (qi < 2) {
        track('quiz_step_complete', { step: qi + 1, answer: answers[qi] });
        qi++;
        renderQ();
        var heading = el('[data-qq]');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
        return;
      }
      var strong = answers[2] === 'Strong' || answers[2] === 'Very strong';
      var pool = products.filter(function (p) { return p.mood === answers[0]; });
      if (!pool.length) pool = products.slice();
      pool.sort(function (a, b) { return strong ? b.price - a.price : a.price - b.price; });
      var p = pool[0];
      if (!p) return;

      el('[data-qsteps]').style.display = 'none';
      el('[data-qresult]').classList.add('is-show');

      var pick = el('[data-rpick]');
      pick.innerHTML = '<img src="' + p.image + '" alt="" width="64" height="64" loading="lazy">' +
        '<div><div class="osv-qresult__house">' + p.vendor + '</div>' +
        '<b class="osv-qresult__name">' + p.title + '</b>' +
        '<div class="osv-qresult__meta">' + p.meta + ' · ' + p.priceText + '</div></div>';
      pick.href = p.url;

      var strength = { 'Light': 'sits close to skin', 'Medium': 'lasts a full workday', 'Strong': 'is still there at night', 'Very strong': 'leaves a trail' }[answers[2]];
      el('[data-rwhy]').textContent = 'You asked for something ' + answers[0].toLowerCase() + ', mostly for ' +
        answers[1].toLowerCase() + ', that ' + strength + '. ' + p.title + ' is ' +
        (p.notes ? 'built on ' + p.notes + ', ' : '') +
        (p.rating ? 'rated ' + p.rating + ' by ' + p.count + ' buyers, ' : '') + 'and in stock now.';
      el('[data-rview]').href = p.url;

      track('quiz_complete', { mood: answers[0], occasion: answers[1], strength: answers[2], match: p.title });
      var result = el('[data-qresult]');
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
      if (!reduceMotion) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    el('[data-rreset]').addEventListener('click', function () {
      qi = 0; answers = [];
      el('[data-qresult]').classList.remove('is-show');
      el('[data-qsteps]').style.display = 'block';
      renderQ();
      track('quiz_restart', {});
    });
  });

  /* ---------- free delivery progress bar ---------- */
  (function () {
    var bar = document.querySelector('[data-osv-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold || '0', 10);
    if (!threshold) return;
    var textEl = bar.querySelector('[data-osv-ship-text]');
    var fillEl = bar.querySelector('[data-osv-ship-fill]');
    var format = bar.dataset.moneyFormat || '{{amount}}';

    // Mirrors Shopify's money filter for the formats a storefront actually uses.
    function money(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var out = format
        .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
      return out.replace(/<[^>]*>/g, '').trim();
    }

    function render(total, itemCount) {
      var earned = total >= threshold;
      bar.classList.toggle('is-show', itemCount > 0);
      bar.classList.toggle('is-earned', earned);
      var pct = Math.min(100, Math.round(total * 100 / threshold));
      if (fillEl) fillEl.style.width = pct + '%';
      if (!textEl) return;
      textEl.textContent = earned
        ? '✓ Free delivery unlocked on this order.'
        : 'Add ' + money(threshold - total) + ' more for free delivery.';
    }

    var refreshing = false;
    function refresh() {
      if (refreshing) return;
      refreshing = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(cart.total_price, cart.item_count); })
        .catch(function () {})
        .then(function () { refreshing = false; });
    }

    // The theme mutates the cart with fetch and publishes no event, so requests to the cart
    // endpoints are observed and the bar is refreshed once each settles.
    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isCartWrite = /\/cart\/(add|change|update|clear)/.test(url);
        var result = nativeFetch.apply(this, arguments);
        if (isCartWrite && result && typeof result.then === 'function') {
          result.then(function () { setTimeout(refresh, 60); }, function () {});
        }
        return result;
      };
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  })();

  /* ---------- product page: gallery ---------- */
  (function () {
    var main = document.querySelector('.osv-pdp__main img');
    if (!main) return;
    var enlarge = document.querySelector('[data-osv-enlarge]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.osv-pdp__thumb'));
    if (!thumbs.length) return;

    function show(index, focusThumb) {
      var b = thumbs[index];
      if (!b) return;
      main.src = b.dataset.src;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.alt = b.dataset.alt || main.alt;
      if (enlarge) enlarge.href = b.dataset.fullSrc || b.dataset.src;
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); x.tabIndex = -1; });
      b.setAttribute('aria-current', 'true');
      b.tabIndex = 0;
      if (focusThumb) b.focus();
    }

    thumbs.forEach(function (b, i) {
      b.tabIndex = b.getAttribute('aria-current') === 'true' ? 0 : -1;
      b.addEventListener('click', function () { show(i, false); });
      // Roving tabindex: one stop for the whole strip, arrows move within it.
      b.addEventListener('keydown', function (e) {
        var rtl = document.documentElement.dir === 'rtl';
        var forward = rtl ? 'ArrowLeft' : 'ArrowRight';
        var back = rtl ? 'ArrowRight' : 'ArrowLeft';
        if (e.key === forward || e.key === 'ArrowDown') { e.preventDefault(); show((i + 1) % thumbs.length, true); }
        else if (e.key === back || e.key === 'ArrowUp') { e.preventDefault(); show((i - 1 + thumbs.length) % thumbs.length, true); }
        else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
        else if (e.key === 'End') { e.preventDefault(); show(thumbs.length - 1, true); }
      });
    });
  })();

  /* ---------- product page: sticky buy bar ---------- */
  (function () {
    var sticky = document.querySelector('[data-osv-sticky]');
    var atc = document.querySelector('[data-osv-atc-anchor]');
    if (!sticky || !atc || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting;
      sticky.classList.toggle('is-show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 }).observe(atc.querySelector('button[type="submit"], [type="submit"]') || atc);

    var sb = sticky.querySelector('[data-osv-sticky-atc]');
    if (!sb) return;
    sb.addEventListener('click', function () {
      var real = atc.querySelector('button[type="submit"], [type="submit"]');
      if (real) real.click();
    });
  })();
})();
